<template>

  <l-table
    ref="LTable"
    :module-name="MODULE_NAME"
    :table-columns="tableColumns"
    :filter-class="filterClass"
  >
    <template #cell(dc_type)="{data}">
      {{ $langName(getDcType(data.value).name) }}
    </template>

    <template #cell(user)="{data}">
      {{ data.value.full_name }}
    </template>

    <template #cell(period)="{data}">
      {{ data.item.period + '/' +data.item.quarter }}
    </template>

    <template #cell(organization)="{data}">
      {{ $langName(data.value) }}
    </template>

    <template #cell(direction_name)="{data}">
      {{ data.item.direction_code + ' - ' + $langName(data.value) }}
    </template>

    <template #cell(is_certificate)="{ data }">
      <b-badge :variant="data.value ? 'success': 'danger'">
        {{ $t(data.value ? 'Yes': 'No') }}
      </b-badge>
    </template>

    <template #cell(is_accepted)="{ data }">
      <b-badge :variant="getExamResultColor(data.value)">
        {{ $langName(getExamResultStatus(data.value).name) }}
      </b-badge>
    </template>
  </l-table>
</template>

<script>
import {
  BBadge,
  VBToggle,
} from 'bootstrap-vue'
import { onUnmounted } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import store from '@/store'
import config from './config'
import allExamsModule from '@/store/all-exams/index'
import periodModule from '@/store/period/index'
import LTable from '@/views/components/LTable.vue'
import AllExams from '@/views/components/filters/service/AllExams'

export default {
  directives: {
    Ripple,
    'b-toggle': VBToggle,
  },
  components: {
    BBadge,
    LTable,
  },
  mounted() {
    this.loadData()
  },
  methods: {
    getDcType(id) {
      return this.$store.getters['staticModule/getDcType'](id)
    },
    toggleFilter() {
      this.FILTER = !this.FILTER
    },
    refetchTable(extraParams) {
      this.$refs.LTable.extraParams = {
        ...this.$refs.LTable.extraParams,
        ...extraParams,
      }
      this.refetchData()
    },
    refetchData() {
      this.$refs.LTable.refetchData()
    },
    loadData() {
      this.$store.dispatch('staticModule/universityList')
      this.$store.dispatch('period/list', { limit: 9999, ordering: '-admission_year' })
      this.refetchTable()
    },
    getExamResultStatus(status) {
      return this.$store.getters['staticModule/getExamResultStatus'](status)
    },
    getExamResultColor(status) {
      return this.$store.getters['staticModule/getExamResultColor'](status)
    },
  },
  setup() {
    const filterClass = new AllExams()
    const MODULE_NAME = 'allExams'
    const MODULE_PERIOD = 'period'
    // Register module
    if (!store.hasModule(MODULE_NAME)) store.registerModule(MODULE_NAME, allExamsModule)
    if (!store.hasModule(MODULE_PERIOD)) store.registerModule(MODULE_PERIOD, periodModule)
    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(MODULE_NAME)) store.unregisterModule(MODULE_NAME)
      if (store.hasModule(MODULE_PERIOD)) store.unregisterModule(MODULE_PERIOD)
    })
    return {
      ...config(),
      MODULE_NAME,
      filterClass,
    }
  },
}
</script>
